import React from "react"
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})

const initialState = {
    dataSavedFilters: [], isLoadingDataSavedFilters: true, page: "COMPETITION", isEditingName: {}, reloadPageFilters: false
}

export function CommonFiltersSavedProvider ({children}) {
    const { state, replaceState, updateState, updatePrevState } = useAppContextState(initialState)

    return <Context.Provider value={{state, replaceState, updateState, updatePrevState}}>
        {children}
    </Context.Provider>
}

export default Context